import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";

import ICInput from "../form/input";

const RecordsColumnsSearch = props => {
  let colInputInterval = useRef();

  const [recordsLimit, setRecordsLimit] = useState("10");
  const [textSearch, setTextSearch] = useState("");

  // restore previous record limit
  useEffect(() => {
    setRecordsLimit(props.recordLimit);
  }, []);

  const applyRecordsFilter = val => {
    setRecordsLimit(val);
    props.setFilters({
      text: textSearch,
      limit: val
    });
  };

  const handleInputChange = val => {
    // here this timeout logic is applied to tackle user input stopped so that we only call function when the user have stopped typing
    clearTimeout(colInputInterval.current);
    setTextSearch(val);

    colInputInterval.current = setTimeout(() => {
      props.setFilters({
        text: val,
        limit: recordsLimit
      });
    }, 1000);
  };

  return (
    <div className="d-flex flex-row justify-content-between flex-wrap">
      <div className="d-flex flex-row align-items-center">
        <span>Records per page:</span>
        <TextField
          style={{ width: "75px" }}
          className="ml-2"
          select
          value={recordsLimit}
          SelectProps={{
            native: true
          }}
          onChange={e => applyRecordsFilter(e.target.value)}
        >
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
          {/*<option value="150">150</option>
          
            {!props.disbleAll && <option value={props.totalRecords}>All</option>}
          */}
        </TextField>
      </div>
      {!props.disableSearchText && (
        <div className="d-flex flex-row align-items-center">
          <span>{props.searchColumnText}</span>
          <ICInput
            name="searchColumnsInput"
            className="ml-2 search-columns-input"
            type="text"
            value={textSearch}
            onChange={e => handleInputChange(e.target.value)}
          />
        </div>
      )}
    </div>
  );
};

export default RecordsColumnsSearch;

RecordsColumnsSearch.defaultProps = {
  recordLimit: 10,
  totalRecords: 10,
  disbleAll: false,
  disableSearchText: false,
  searchColumnText: "Search all columns:"
};

RecordsColumnsSearch.prototype = {
  recordLimit: PropTypes.string,
  totalRecords: PropTypes.number.isRequired,
  setFilters: PropTypes.func.isRequired,
  disbleAll: PropTypes.bool, // diable all data at once
  disableSearchText: PropTypes.bool, //disable the search text field,
  searchColumnText: PropTypes.string
};
